import { Injectable } from '@angular/core';
import { Cxcencregcomp } from "../cxcinterfaces/cxcencregcomp";
import { Cxcdetregcomp } from "../cxcinterfaces/cxcdetregcomp";
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';


@Injectable({
  providedIn: 'root'
})
export class CxcdetcomprobanteService {
  public _detregcomp: Cxcdetregcomp[];
  get detregcomp(): Cxcdetregcomp[] {
    return this._detregcomp;
  }

  set detregcomp(value: Cxcdetregcomp[]) {
    this._detregcomp = value;
  }
  private way: string;

    constructor(
    private confIniciales: ConfInicialesService,
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
  ) {
    this.way = sessionStorage.getItem('way');
  }


  getdetregcomprobante(){
    return this.http.post<any[]>(this.way + '/cxc/cxcdetregcompo/83bad7776e833000000000000', {
      elementos: {
        p_com_codigo:'01'
       },

    }, this.confIniciales.httpOptions()
    ).toPromise();
  }
  getdetregcomprobantefp(){
    return this.http.post<any[]>(this.way + '/cxc/cxcdetregcompo/20eeb5dddba0cc0000', {
      elementos: {
        p_com_codigo:'01'
       },

    }, this.confIniciales.httpOptions()
    ).toPromise();
  }
  actualizarregistrodet(item) {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/299df2ab2', {
      elementos: {
        p_encregcompro_numero :item.ENCREGCOMPRO_NUMERO ,
        p_com_codigo :'01',
        p_ban_codigo :item.BAN_CODIGO ,
        p_DETREGCOMPRO_COMPROBANTE :item.DETREGCOMPRO_COMPROBANTE ,
        p_detregcompro_referencia2 :item.DETREGCOMPRO_REFERENCIA2 ,
        p_cli_codigo :item.CLI_CODIGO
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetregcomprobanteban(bancos){
    return this.http.post<any[]>(this.way + '/cxc/cxcdetregcompo/83bad7776e82d80', {
      elementos: {
        p_ban_codigo:bancos
       },

    }, this.confIniciales.httpOptions()
    ).toPromise();
  }
}
